import { Stack } from "@fluentui/react";
import { SectionPage } from "@snsw-gel/react";
import SnswAvatar from "../../assets/snswAvatar";
import styles from "../Answer/Answer.module.css";

type Variant = "loading" | "error";

interface Props {
  variant?: Variant;
  message?: string;
  showDots?: boolean;
}

export const AnswerStatus = ({ variant = "loading", message, showDots = true }: Props) => {
  const isError = variant === "error";
  const text = message ? message : isError ? "Something went wrong. Please try again later." : "Generating answer";

  return (
    <div>
      <Stack className={styles.answerContainer} verticalAlign="space-between">
        <SectionPage className={styles.answerRoleChatGPT}>
          <SnswAvatar />
          <h4 className={styles.answerGPTTitle}>Sage</h4>
        </SectionPage>

        <p className={styles.answerText}>
          {text}
          {!isError && showDots && <span className={styles.loadingdots} />}
        </p>
      </Stack>
    </div>
  );
};
